import * as dayjs from "dayjs";
import * as LocalizedFormat from "dayjs/plugin/localizedFormat";
import * as utc from "dayjs/plugin/utc";
import * as localeData from "dayjs/plugin/localeData";
import * as timezone from "dayjs/plugin/timezone";
import * as isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import * as isSameOrAfter from "dayjs/plugin/isSameOrAfter";

import "dayjs/locale/fr";

const locale = document.documentElement.lang;
dayjs.extend(LocalizedFormat).locale(locale);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export default dayjs;
